import React from 'react';
import { ChatDayGroupedMessages } from 'src/pages/Conversations/Chat/chat-day-grouped-messages';
import { MessageItemSkeleton } from 'src/pages/Conversations/Chat/ChatMessage/chat-message';
import { useAllBlockingResolved, useChatPagination, useMergedTimeline } from './hooks';
import { messageRegistry } from './index';
import { RegistryRow } from './RegistryRow';

const ChatThreadSkeleton = (): React.JSX.Element => <MessageItemSkeleton />;

const ChatThread = (): React.JSX.Element => {
  const entries = useMergedTimeline();
  const { shouldRender } = useAllBlockingResolved();
  const { isLoadingMore } = useChatPagination();

  if (!shouldRender) {
    return <ChatThreadSkeleton />;
  }

  return (
    <>
      <ChatDayGroupedMessages
        messageList={entries}
        renderMessage={(entry) => {
          const registration = messageRegistry[entry.type];
          if (!registration) return null;
          return (
            <RegistryRow
              key={`${entry.type}:${registration.getKey(entry.item)}`}
              registration={registration}
              item={entry.item}
            />
          );
        }}
      />
      {isLoadingMore ? <MessageItemSkeleton /> : null}
    </>
  );
};

export default ChatThread;
